<script>
  import Button, { Icon, Label } from '@smui/button';
  import SubscribeSnack from '$lib/client/shared/subscribe-snack.svelte';
  import { Stretch } from 'svelte-loading-spinners';
import { channel } from '$lib/store';
import { audio, states } from '$lib/audio-store';
  import { playlist } from '$lib/playlist-store';

  export let track;

  let loaded = false;

let label = `Please support ${track?.artist?.name?.toUpperCase()} and subscribe now! As well as funding the development of Most Rated, your pledge is split amongst the artists you rate, directly supporting grassroots indie musicians. `
let snackbar;

  async function playTrack() {
    // Might be a bug here. What if the channel is playing this track and you're trying to play it from the feed? Seems like a rare edge case...
    if (track.id !== $playlist.currentTrack?.id) {
      const trackStreamApiUrl = `/api/tracks/${track.id}/stream`;
      try {
        const { url, showSubscriptionAsk } = await fetch(trackStreamApiUrl).then((response) => response.json());

        loaded = true;
        if(showSubscriptionAsk) snackbar.open();
        track.ends_at = Date.now() + track.audio.duration;
        playlist.replace([track]);
        playlist.cancelScheduleSubscription()
        await audio.stop().then(() => audio.change(url).then(() => audio.play()));
      } catch (error) {
        console.error(error);
      }
    } else {
      await audio.play()
    }
  }
</script>

{#if track.id === $playlist.currentTrack?.id}
  {#if $audio.state === states.PLAYING}
    <Button class="play u-pl-none" on:click={audio.stop}>
      <Icon class="material-icons u-mr-small">stop_circle</Icon>

      <Label>Stop</Label>
    </Button>
  {/if}

  {#if $audio.state === states.PAUSED}
    <Button class="paused u-pl-none" on:click={playTrack}>
      <Icon class="material-icons u-mr-small">pause_circle</Icon>

      <Label>Listen Now</Label>
    </Button>
  {/if}

  {#if $audio.state === states.BUFFERING}
    <div class="buffering">
      <Stretch duration="2s" size="40" color="#00CCFE" />
    </div>
  {/if}

  {#if $audio.state === states.OFFLINE}
    <Button on:click={playTrack} class="u-pl-none">
      <Icon class="material-icons offline">media_bluetooth_off</Icon>
      <Label class="t-left">No sound. Sorry!</Label>
    </Button>
  {/if}

  {#if $audio.state === states.STOPPED}
    <Button class="play u-pl-none" on:click={playTrack}>
      <Icon class="material-icons u-mr-small">play_circle</Icon>
      <Label>Listen Now</Label>
    </Button>
  {/if}
{:else}
  <Button class="play u-pl-none" on:click={playTrack}>
    <Icon class="material-icons u-mr-small">play_circle</Icon>
    <Label>Listen Now</Label>
  </Button>
{/if}

<SubscribeSnack bind:snackbar {label} />
